import(/* webpackMode: "eager" */ "/app/apps/location-app-router/app/[locale]/error.tsx");
